import { isEmptyOrSpacesString } from 'shared/lib'
import { type IRcsComplianceData } from 'entities/Rcs/api'

export const isEmptyRcsValue = (value: unknown): boolean => {
  if (value === null || value === undefined) return true
  if (typeof value === 'string') return isEmptyOrSpacesString(value)
  if (Array.isArray(value)) return value.length === 0
  if (typeof value === 'object') return Object.values(value).every(isEmptyRcsValue)

  return false
}

export const isRcsComplianceDataEmpty = (data: IRcsComplianceData | null | undefined): boolean =>
  isEmptyRcsValue(data)
